// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default } from './view';
export const controlHeight = 58;
